import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconTools from '@/icons/Tools.svg';

export const ArticleExchangeStartedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_exchange_started'>;
  displayArticleName: boolean;
}) => {
  const workshopName = activity.entity.name;
  const creatorName = activity.creator?.name;
  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconTools />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfWorkshop ? (
            <Trans id="activities.article_exchange_started.message.on-behalf">
              <strong>{creatorName}</strong> started the exchange on behalf of{' '}
              <strong>{workshopName}</strong> for the item {articleName}
            </Trans>
          ) : (
            <Trans id="activities.article_exchange_started.message">
              <strong>{creatorName}</strong> started the exchange of the item {articleName}
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
